import React from "react";
import BulkUploadRolesModal from "../../../components/Roles/BulkUploadRolesModal";

const RolesBulkUpload = () => {
  return <BulkUploadRolesModal />;
};

export default RolesBulkUpload;
